/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Prospects_Remove_Confirmmodal_Description2Inputs */

const en_coinvestments_prospects_remove_confirmmodal_description2 = /** @type {(inputs: Coinvestments_Prospects_Remove_Confirmmodal_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This action cannot be undone.`)
};

/**
* | output |
* | --- |
* | "This action cannot be undone." |
*
* @param {Coinvestments_Prospects_Remove_Confirmmodal_Description2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_prospects_remove_confirmmodal_description2 = /** @type {((inputs?: Coinvestments_Prospects_Remove_Confirmmodal_Description2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Prospects_Remove_Confirmmodal_Description2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_prospects_remove_confirmmodal_description2(inputs)
});
export { coinvestments_prospects_remove_confirmmodal_description2 as "coInvestments_prospects_remove_confirmModal_description" }